import { AlertTransparentColorType } from '../types/alert-transparent.type';

export const ALERT_TRANSPARENT_COLORS_MAP: Record<AlertTransparentColorType, string> = {
  orange: '',
  red: 'fr8bot-alert-transparent--red',
};
